import LockIcon from '@/shared-components/icons/components/public/LockIcon';

import './SoldPriceValue.css';

export default function SoldPriceValue({ artworkData, value, onUnlock, pending = false, className = '' }) {
  const access = artworkData?.sold_price_access?.status;
  if (access === 'unlocked') return <span className={className}>{value}</span>;
  if (!access) return <span className={className}>—</span>;

  const actionLabel = pending
    ? 'Unlocking sold artwork prices'
    : access === 'free_available'
      ? 'Unlock sold artwork prices'
      : 'Unlock sold artwork prices with Suarte Plus';

  return (
    <button
      type="button"
      className="sold-price-unlock"
      onClick={() => onUnlock?.(artworkData)}
      disabled={pending}
      aria-label={actionLabel}
      aria-busy={pending}
      title={actionLabel}
    >
      <LockIcon className="sold-price-unlock__icon" />
    </button>
  );
}
